export const DOCUMENT_TITLE_LIMIT = 70;
export const SITE_NAME = "Garimpa.Club";
const SITE_TITLE_SUFFIX = ` | ${SITE_NAME}`;
const LEGACY_SITE_TITLE_PREFIX = `${SITE_NAME} - `;

export function withSiteTitle(title: string): string {
  const coreTitle = titleCore(title);
  if (!coreTitle) return SITE_NAME;

  const coreLimit = DOCUMENT_TITLE_LIMIT - SITE_TITLE_SUFFIX.length;
  return `${clipTitleCore(coreTitle, coreLimit)}${SITE_TITLE_SUFFIX}`;
}

function titleCore(title: string): string {
  const normalized = title.trim();
  if (!normalized || normalized === SITE_NAME) return "";
  if (normalized.endsWith(SITE_TITLE_SUFFIX)) {
    return normalized.slice(0, -SITE_TITLE_SUFFIX.length).trim();
  }
  if (normalized.startsWith(LEGACY_SITE_TITLE_PREFIX)) {
    return normalized.slice(LEGACY_SITE_TITLE_PREFIX.length).trim();
  }
  return normalized;
}

function clipTitleCore(title: string, maxLength: number): string {
  if (title.length <= maxLength) return title;

  const sliced = title.slice(0, maxLength - 1);
  const lastSpace = sliced.lastIndexOf(" ");
  const clipped = lastSpace > maxLength * 0.65 ? sliced.slice(0, lastSpace) : sliced;
  return `${clipped.trimEnd()}…`;
}
